export default __webpack_public_path__ + "static/media/authyBackground.b07861b1.png";